import { useNavigation } from "@react-navigation/native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CheckCircle, Users } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { XStack } from "tamagui";
import { useStores } from "../../core/stores";
import { Button } from "../../ui/Button";
import { UserAvatarGroupRaw } from "../../ui/UserAvatarGroupRaw";
import { BusinessPlaniraLoader } from "../components/BusinessPlaniraLoader";
import { BusinessTasksList } from "../modules/ui/BusinessTasksList";
import BusinessPlanScreen from "./BusinessPlanScreen";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "BusinessTasks"
>;

export const BusinessTasksScreen = observer((props: Props) => {
  const { businessPlansStore } = useStores();

  const { navigate } = useNavigation();
  const businessPlan = businessPlansStore.byId.get(
    props.route.params.businessUid,
  );

  const teamsTabEnabled =
    businessPlan?.data.eventInfo.settings?.usePlanira ?? false;
  const showTeamsTab = props.route.params.tab === "team";

  return (
    <BusinessPlanScreen {...props}>
      {businessPlan && teamsTabEnabled ? (
        <>
          <XStack>
            <Button
              iconPosition={"before"}
              icon={CheckCircle}
              style={{ flex: 1 }}
              type={!showTeamsTab ? "primary" : "secondary"}
              onPress={() => {
                navigate("BusinessTasks", {
                  businessUid: businessPlan.uid,
                });
              }}
            >
              {businessPlan.data.customerInfo.name}
            </Button>
            <Button
              iconPosition={"before"}
              icon={Users}
              style={{ flex: 1 }}
              type={showTeamsTab ? "primary" : "secondary"}
              onPress={() => {
                navigate("BusinessTasks", {
                  businessUid: businessPlan.uid,
                  tab: "team",
                });
              }}
            >
              My Team
            </Button>
          </XStack>
          {!showTeamsTab && (
            <>
              <UserAvatarGroupRaw
                businessPlan={businessPlan}
                users={businessPlan.planUsersSorted}
                onPress={() => {
                  navigate("BusinessMembers", {
                    businessUid: businessPlan.uid,
                  });
                }}
              />
              <BusinessTasksList businessPlan={businessPlan} />
            </>
          )}
          {showTeamsTab && (
            <BusinessPlaniraLoader businessPlan={businessPlan} />
          )}
        </>
      ) : null}

      {businessPlan && !teamsTabEnabled && (
        <BusinessTasksList businessPlan={businessPlan} />
      )}
    </BusinessPlanScreen>
  );
});

export default BusinessTasksScreen;
